import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {ReserveWithSearch} from '../containers'
function ReserveWithSearchPage() {
    console.log('sv****ReserveWithSearchPage')
    let { id,spaceKey } = useParams();console.log('sv****ReserveWithSearchPage',id,spaceKey )

    let svparams = { 'id': id, 'spaceKey':spaceKey}
    return (
        <ReserveWithSearch svparams= {svparams} />
       
    );
}
export default ReserveWithSearchPage